





























import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import GiftPackage from '@/store/entities/gift-package';
import dayjs from "dayjs";
import Campaign from "@/store/entities/campaign";


@Component
export default class CreateGiftPackage extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;
  giftPackage: GiftPackage = new GiftPackage();

  get loading() {
    return this.$store.state.giftPackage.loading;
  }

  get permissions() {
    return this.$store.state.giftPackage.permissions
  }


  save() {
    (this.$refs.giftPackageForm as any).validate(async (valid: boolean) => {
      if (valid) {

        let m = this.$store.state.main.campaign as Campaign;

        if (!m) {
          this.$Message.error('请选择活动');
          return;
        }

        this.giftPackage.campaignCode = m.campaignCode;
        this.giftPackage.campaignId = m.id;

        await this.$store.dispatch({
          type: 'giftPackage/create',
          data: this.giftPackage
        });
        (this.$refs.giftPackageForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);
      }
    })
  }

  cancel() {
    (this.$refs.giftPackageForm as any).resetFields();
    this.$emit('input', false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    } else {
      this.giftPackage = new GiftPackage();
      
    }
  }

  giftPackageRule = {
    packageName: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('packageName')),
      trigger: 'blur'
    }],
    packageCode: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('packageCode')),
      trigger: 'blur'
    }]
  }
}
